/**
 * Localizes breadcrumb magazine name based on language
 * @param {Object} breadcrumb - The breadcrumb object from the backend
 * @param {string} language - The current language code (fr, en, es, it, de)
 * @returns {Object} - The breadcrumb object with localized magazine name
 */
export const localizeBreadcrumbMagazineName = (breadcrumb, language) => {
  if (!breadcrumb || typeof breadcrumb !== "object") {
    return breadcrumb;
  }

  let localizedBreadcrumb = {...breadcrumb};
  if (language !== "fr") {
    const magazineNameFr = "ViaMichelin Le Mag";
    const valuePath = breadcrumb[magazineNameFr];
    delete localizedBreadcrumb[magazineNameFr];

    const magazineNameForOtherLanguages = "ViaMichelin Magazine";
    localizedBreadcrumb = {
      [magazineNameForOtherLanguages]: valuePath,
      ...localizedBreadcrumb,
    };
  }

  return localizedBreadcrumb;
};
